






















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {}
})
export default class LoginToast extends Vue {
  @Prop({ default: "" })
  private title!: string;
  @Prop({ default: "" })
  private content!: string;
  @Prop({ default: [] })
  private buttonGroup!: any;
}
